(function () {
  function initializeMobileBuy(container, isReady) {
    if (container.dataset.ystwMobileBuyReady === 'true' || container.dataset.modal === 'true') {
      return function () {};
    }

    container.dataset.ystwMobileBuyReady = 'true';
    var bar = document.createElement('div');
    bar.className = 'ystw-mobile-buy';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ystw-mobile-buy__copy"><span>Ready when you are</span><strong></strong></div>' +
      '<button class="btn ystw-mobile-buy__button" type="button"></button>';
    bar.querySelector('strong').textContent = container.dataset.productTitle || 'Selected style';
    document.body.appendChild(bar);

    var stickyButton = bar.querySelector('.ystw-mobile-buy__button');
    var addButton = null;
    var addButtonText = null;
    var nativeButtonVisible = true;
    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        nativeButtonVisible = entries[0].isIntersecting;
        sync();
      },
      { threshold: 0.05 }
    );

    function refreshNativeButton() {
      var nextButton = container.querySelector('[data-add-to-cart]');
      if (nextButton === addButton) return;
      if (addButton) visibilityObserver.unobserve(addButton);
      addButton = nextButton;
      addButtonText = container.querySelector('[data-add-to-cart-text]');
      nativeButtonVisible = true;
      if (addButton) visibilityObserver.observe(addButton);
    }

    function sync() {
      refreshNativeButton();
      if (!addButton || !addButtonText) return;
      var ready = isReady();
      stickyButton.textContent = addButtonText.textContent.trim();
      stickyButton.disabled = addButton.disabled || !ready;
      bar.classList.toggle('is-visible', ready && !nativeButtonVisible);
      bar.setAttribute('aria-hidden', ready && !nativeButtonVisible ? 'false' : 'true');
    }

    stickyButton.addEventListener('click', function () {
      refreshNativeButton();
      if (!stickyButton.disabled) addButton.click();
    });

    new MutationObserver(sync).observe(container, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true,
    });

    sync();
    return sync;
  }

  function initializeSizeGate(container) {
    if (container.dataset.ystwSizeGateReady === 'true') return;

    var sizeGroup = container.querySelector('.variant-input-wrap[data-handle="size"]');
    var addButton = container.querySelector('[data-add-to-cart]');
    var addButtonText = container.querySelector('[data-add-to-cart-text]');
    if (!sizeGroup || !addButton || !addButtonText) return;

    var sizeInputs = Array.prototype.slice.call(sizeGroup.querySelectorAll('[data-variant-input]'));
    var optionInputs = Array.prototype.slice.call(container.querySelectorAll('[data-variant-input]'));

    if (container.dataset.productAvailable === 'false') {
      container.dataset.ystwSizeGateReady = 'true';

      function resetSoldOutState() {
        sizeInputs.forEach(function (input) {
          input.checked = false;
        });
        addButton.disabled = true;
        addButton.classList.add('disabled');
        addButtonText.textContent = theme.strings.soldOut;
      }

      optionInputs.forEach(function (input) {
        if (sizeInputs.indexOf(input) !== -1) return;
        input.addEventListener('change', function () {
          window.requestAnimationFrame(resetSoldOutState);
        });
      });

      resetSoldOutState();
      return;
    }

    var sizeChosen = container.dataset.modal !== 'true' && new URLSearchParams(window.location.search).has('variant');

    container.dataset.ystwSizeGateReady = 'true';
    var syncMobileBuy = initializeMobileBuy(container, function () {
      return sizeChosen;
    });
    if (sizeChosen) return;

    function resetSizeGate() {
      if (sizeChosen) return;
      sizeInputs.forEach(function (input) {
        input.checked = false;
      });
      addButton.disabled = true;
      addButton.classList.add('disabled');
      addButtonText.textContent = 'Choose a size';
    }

    sizeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        sizeChosen = true;
        window.requestAnimationFrame(syncMobileBuy);
      });
    });

    optionInputs.forEach(function (input) {
      if (sizeInputs.indexOf(input) !== -1) return;
      input.addEventListener('change', function () {
        sizeChosen = false;
        window.requestAnimationFrame(resetSizeGate);
      });
    });

    resetSizeGate();
  }

  function initialize(root) {
    root.querySelectorAll('[data-ystw-require-size="true"]').forEach(initializeSizeGate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('quickview:loaded', function () {
    initialize(document);
  });
})();
